import {
	ChangeExpiredPassword,
	ConfirmAccount,
	ContactUs,
	Coworkers,
	Dashboard,
	DefinePassword,
	Error500,
	Login,
	Patient,
	Patients,
	PsychologistsAppointments,
	PsychologistsChat,
	PsychologistsHome,
	PsychologistsProfile,
	RecoverPassword,
	Report,
	Treatment,
	UserHome,
	UsersAppointments,
	UsersChat,
	UsersProfile
} from "screens";
import { Redirect, Route, Switch } from "react-router-dom";

import React from "react";
import { connect } from "react-redux";

export const offlinePages = ["/login", "/register", "/accept-invite", "/recover-password", "/confirm", "/change-expired-password"];
export const localhostType = "users"; // users or psychologists
export const usersSubDomains = ["mydev", "my"];
export const psychologistsSubDomains = ["psicdev", "psic"];

// Path kept across the login redirect (e.g. the e-mail confirmation link /profile/:code opened without a session).
export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

// Only internal paths are accepted: must start with a single "/" (never absolute or protocol-relative URLs;
// browsers also read "/\" as "//").
export const isInternalPath = (path: any): path is string => typeof path === "string" && /^\/(?![/\\])/.test(path);

export const savePostLoginRedirect = (path: string) => {
	if (!isInternalPath(path)) return;

	try {
		sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
	} catch (err) {}
};

export const consumePostLoginRedirect = (): string | null => {
	try {
		const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
		sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

		return isInternalPath(path) ? path : null;
	} catch (err) {
		return null;
	}
};

// Stores the requested path before sending an unauthenticated user to /login, so Login can return to it.
class RedirectToLogin extends React.Component<any> {
	componentDidMount() {
		savePostLoginRedirect(this.props.location?.pathname);
	}

	render() {
		return <Redirect to="/login" />;
	}
}

export class Routes extends React.Component<any, any> {
	componentDidUpdate() {
		const elem = document.getElementById("app_content");

		if (elem) {
			elem.scrollTop = 0;
		}
	}

	render() {
		const { token, user } = this.props;
		const hostname = window.location.hostname?.split(".")?.[0];

		if (
			// @ts-ignore
			(hostname === "localhost" && localhostType === "users" && token) ||
			(usersSubDomains.includes(hostname) && token)
		) {
			if (user?.isHR) {
				return (
					<Switch>
						<Route exact path="/profile" component={UsersProfile} />
						<Route exact path="/profile/:code" component={UsersProfile} />
						<Route exact path="/dashboard" component={Dashboard} />
						<Route exact path="/coworkers" component={Coworkers} />
						<Route exact path="/contact-us" component={ContactUs} />
						<Route exact path="/500" component={Error500} />
						<Redirect to="/dashboard" />
					</Switch>
				);
			}

			return (
				<Switch>
					<Route exact path="/home" component={UserHome} />
					<Route exact path="/appointments" component={UsersAppointments} />
					<Route exact path="/chat" component={UsersChat} />
					<Route exact path="/profile" component={UsersProfile} />
					<Route exact path="/profile/:code" component={UsersProfile} />
					<Route exact path="/contact-us" component={ContactUs} />
					<Route exact path="/500" component={Error500} />
					<Redirect to="/home" />
				</Switch>
			);
		} else if (
			// @ts-ignore
			(hostname === "localhost" && localhostType === "psychologists" && token) ||
			(psychologistsSubDomains.includes(hostname) && token)
		) {
			return (
				<Switch>
					<Route exact path="/home" component={PsychologistsHome} />
					<Route exact path="/patients" component={Patients} />
					<Route exact path="/patients/:id" component={Patient} />
					<Route exact path="/patients/:id/treatment/:idTreatment" component={Treatment} />
					<Route exact path="/appointments" component={PsychologistsAppointments} />
					<Route exact path="/appointments/:id/report" component={Report} />
					<Route exact path="/chat" component={PsychologistsChat} />
					<Route exact path="/profile" component={PsychologistsProfile} />
					<Route exact path="/profile/:code" component={PsychologistsProfile} />
					<Route exact path="/contact-us" component={ContactUs} />
					<Route exact path="/500" component={Error500} />
					<Redirect to="/home" />
				</Switch>
			);
		} else {
			if (
				// @ts-ignore
				(hostname === "localhost" && localhostType === "psychologists") ||
				psychologistsSubDomains.includes(hostname)
			) {
				return (
					<Switch>
						<Route exact path="/login" component={Login} />
						<Route
							exact
							path="/confirm-account"
							component={(props: any) => <ConfirmAccount {...props} isPsychologist />}
						/>
						<Route
							exact
							path="/confirm-account/:email/:code"
							component={(props: any) => <DefinePassword {...props} isPsychologist />}
						/>
						<Route
							exact
							path="/recover-password"
							component={(props: any) => <RecoverPassword {...props} isPsychologist />}
						/>
						<Route
							exact
							path="/recover-password/:email/:code"
							component={(props: any) => <RecoverPassword {...props} isPsychologist />}
						/>

						<Route exact path="/500" component={Error500} />
						<Route exact path="/profile/:code" component={RedirectToLogin} />
						<Redirect to="/login" />
					</Switch>
				);
			}

			return (
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/confirm-account" component={ConfirmAccount} />
					<Route exact path="/confirm-account/:email/:code" component={DefinePassword} />
					<Route exact path="/recover-password" component={RecoverPassword} />
					<Route exact path="/recover-password/:email/:code" component={RecoverPassword} />
					<Route exact path="/change-expired-password" component={ChangeExpiredPassword} />

					<Route exact path="/500" component={Error500} />
					<Route exact path="/profile/:code" component={RedirectToLogin} />
					<Redirect to="/login" />
				</Switch>
			);
		}
	}
}

const mapStateToProps = (state: any) => ({
	router: state.router,
	user: state.user,
	token: state.token
});

export default connect(mapStateToProps)(Routes);
